import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { schoolSettingService } from '@/service/api/school-setting.service';
import { SchoolSetting } from '@/models/school-setting';

// 学校設定用のstore
export interface ISchoolSettingState {
  schoolSetting: SchoolSetting; // 全受検設定
}
@Module({ dynamic: true, store, name: 'evalSettingModule', namespaced: true })
class SchoolSettingModule extends VuexModule implements ISchoolSettingState {
  schoolSetting: SchoolSetting = new SchoolSetting();

  @Mutation
  setSchoolSetting(value: SchoolSetting) {
    this.schoolSetting = value;
  }

  @Mutation
  setTwoFactorAuth(value: boolean) {
    this.schoolSetting.twoFactorAuth = value;
  }

  /**
   * 学校設定取得
   */
  @Action({ rawError: true })
  async fetchSchoolSettingDetail() {
    const settings = await schoolSettingService.fetch();
    this.setSchoolSetting(settings);
  }

  /**
   * 受検者割り当て情報更新
   * @param evalSettingID
   */
  @Action({ rawError: true })
  updateSchoolSetting(): Promise<SchoolSetting> {
    return schoolSettingService.update(this.schoolSetting);
  }
}

export const schoolSettingModule = getModule(SchoolSettingModule);
